// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1r9Gc","footer":"ModalInfo_footer__28Tjl"};